import React from "react";

export default function SoMobileFilters({
  modalId,
  toolbar,
  title = "Filters",
  downloads,
  downloadsTitle = "Download",
  onSearch,
  onReset,
  searchLabel = "Search",
  resetLabel = "Reset",
}) {
  const safeId = modalId || "so-mobile-filters";
  return (
    <>
      <div className="so-mobileFiltersBar">
        {downloads ? (
          <button
            type="button"
            className="so-filterIconBtn"
            data-bs-toggle="modal"
            data-bs-target={`#${safeId}-dl`}
            aria-label="Open downloads"
          >
            <i className="ri-download-2-line" aria-hidden="true" />
          </button>
        ) : null}
        <button
          type="button"
          className="so-filterIconBtn"
          data-bs-toggle="modal"
          data-bs-target={`#${safeId}`}
          aria-label="Open filters"
        >
          <i className="ri-filter-3-line" aria-hidden="true" />
        </button>
      </div>

      {downloads ? (
        <div className="modal fade so-filtersModal so-filtersModal--downloads" id={`${safeId}-dl`} tabIndex="-1" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{downloadsTitle}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">{downloads}</div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="modal fade so-filtersModal so-filtersModal--filters" id={safeId} tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">{toolbar}</div>
            <div className="modal-footer so-filtersModal__footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                onClick={() => onReset?.()}
              >
                {resetLabel}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => onSearch?.()}
              >
                {searchLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

